import Vue from 'vue';

export const Device = {
    state: {
        device: 'desktop'
    },
    mutations: {
        setDevice(state, payload) {
            state.device = payload;
        }
    },
    getters: {
        getAllDevices() {
            return ['smartphone', 'tablet', 'desktop'];
        },
        getCurrentDevice(state) {
            return state.device;
        },
        isActiveDevice(state) {
            return (device) => {
                return state.device === device;
            };
        },
        getCurrentDeviceClass(state) {
            return 'editor--device-' + state.device;
        }
    },
    actions: {
        async setCurrentDevice(context, payload) {
            let module_id = await context.dispatch('getCurrentlyCenteredModuleId');
            context.commit('setDevice', payload);
            if (module_id !== null) {
                Vue.nextTick(() => {
                    context.dispatch('scrollVerticalCenterModule', { id: module_id });
                });
            }
        },
        async getCurrentlyCenteredModuleId() {
            let module_id = null;
            if (document.querySelector('.module[data-id]') !== null) {
                document.querySelectorAll('.module[data-id]').forEach((el) => {
                    if (module_id !== null) {
                        return;
                    }
                    let offset_top = el.getBoundingClientRect().top;
                    if (offset_top > -75) {
                        module_id = el.getAttribute('data-id');
                    }
                });
            }
            return module_id;
        }
    }
};
